import { useQuery } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useAvailableCurrencies = () => {
  const query = useQuery({
    queryKey: [QueryKeys.AVAILABLE_CURRENCIES],
    queryFn: paymentRepo.getAvailableCurrencies,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseAvailableCurrencies = ReturnType<typeof useAvailableCurrencies>;
